import { Button, ButtonProps } from '@mui/material';
import { FC } from 'react';
import '../Button.scss';

const PrimaryButton: FC<ButtonProps & React.HTMLProps<HTMLButtonElement>> = ({
  children,
  ...props
}) => {
  return (
    <Button variant="contained" {...props}>
      {children}
    </Button>
  );
};

export default PrimaryButton;
